import React from 'react';
import Loading from '../../loading';
import { STATS, TIPS } from './constants';
const Footer = ({ hasMore = false }) => {
    return (React.createElement("div", { className: "pull-load-footer-default" }, hasMore ? React.createElement(Loading, { text: TIPS[STATS.LOADING] }) : TIPS.NOMORE));
};
export default Footer;
